import { useEffect, useState } from 'react';

import { TopRightContent } from './TopRightContent';
import { TopRightFallback } from './TopRightFallback';

export function TopRight() {
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    setFirstRender(false);
  }, []);

  if (typeof window === 'undefined' || firstRender) {
    return <TopRightFallback />;
  }

  return <TopRightContent />;
}
